import { Component, Input, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { RecalculateSchedule } from '../../data-services/recalculate-transactions/recalculate-schedules/recalculate-schedules.model';
import { RecalculateSetting } from '../../data-services/recalculate-transactions/recalculate-settings/recalculate-settings.model';
import { DisplayErrors } from '../../shared/errors-sidenav';

@Component({
    selector: 'ef-settings-presenter',
    templateUrl: './settings-presenter.component.html',
    styleUrls: ['./settings-presenter.component.scss'],
    standalone: false
})
export class SettingsPresenterComponent extends DisplayErrors<RecalculateSetting> implements OnInit {

    private SettingsSubject = new ReplaySubject<Array<RecalculateSetting>>(1);
    private _settings: Array<RecalculateSetting>;
    @Input() set settings(value: Array<RecalculateSetting>) {
        if (value && value.length > 0 && value[0]) {
            value = value.map(x => ({
                ...x,
                SettingValue: x.SettingValue == '1' ? true : false
            }));
        }

        this._settings = value.filter(x => x.CatID == 8);
        this.SettingsSubject.next(value);
    }
    get settings(): Array<RecalculateSetting> {
        return this._settings;
    }

    private SchedulesSubject = new ReplaySubject<Array<RecalculateSchedule>>(1);
    private _schedules: Array<RecalculateSchedule>;
    @Input() set schedules(value: Array<RecalculateSchedule>) {
        this._schedules = value;
        this.SchedulesSubject.next(value);

        if (this._schedules.length > 0) {
            if (this._schedules[0].Timer == true) {

            } else {
                if (this.rowData) {
                    this.UpdateSettings.next({
                        SettingValue: this.checked == true ? '1' : '0',
                        SettingType: this.rowData.SettingType
                    });
                }
            }
        }

    }
    get schedules(): Array<RecalculateSchedule> {
        return this._schedules;
    }

    @Output() UpdateSettings = new ReplaySubject<any>(1);

    @Output() GetSchedules = new ReplaySubject<any>(1);

    checked: boolean;
    rowData: RecalculateSetting;

  constructor() {
      super();
  }

  ngOnInit(): void {
  }

  onCheckboxChange($event, rowData) {
    this.checked = $event.checked;
    this.rowData = rowData;
    this.GetSchedules.next({
        FyStartDate: null,
        FYEndDate: null
    });

  }

}
